<template>
    <div class="wrapper">
        <div class="use">
            <div class="content">
                <span class="logo">
                    <img src="../assets/logo.png" alt="logo">
                </span>
                <div class="head">
                    <header></header>
                    <span class="title">{{ticket.ticketName}}</span>
                </div>
                <div class="body">
                    <div class="code">
                        <div class="tip">券码有效期至{{ticket.expiredDate}},请您尽快完成券码使用,券码超过有效期未使用,服务商无法为您提供换券服务。</div>
                        <div class="qrcode" ref="qrCodeUrl"></div>
                    </div>
                    <div class="sec">兑换码：{{ticket.outTicketPsw}}</div>
                </div>
                <div class="foot">
                    <h1>券码规则</h1>
                    <p>1.黑胶VIP官方兑换码共9位，英文字母加数字，需区分大小写。</p>
                    <p>苹果手机兑换方法</p>
                    <p>1、首先打开网易云音乐，点击“账号”，在账号页面选择“会员中心”。</p>
                    <!-- <img src="https://img.chejianlife.com/ios1.png" alt="网易云音乐ios兑换方法"> -->
                    <img src="https://img.chejianlife.com/ios2.png" alt="网易云音乐ios兑换方法">
                    <img src="https://img.chejianlife.com/ios3.png" alt="网易云音乐ios兑换方法">
                    <p>2、打开后下拉到最下面点击立即开通</p>
                    <img src="https://img.chejianlife.com/ios4.jpg" alt="网易云音乐ios兑换方法">
                    <img src="https://img.chejianlife.com/ios5.png" alt="网易云音乐ios兑换方法">
                    <p>3、选择使用会员兑换码，如图所示。</p>
                    <img src="https://img.chejianlife.com/ios6.png" alt="网易云音乐ios兑换方法">
                    <img src="https://img.chejianlife.com/ios7.png" alt="网易云音乐ios兑换方法">
                    <p>安卓手机兑换方法</p>
                    <!-- <p>1、在手机桌面选择并打开【网易云音乐】应用程序，如图所示；</p>
                    <img src="https://img.chejianlife.com/and1.jpg" alt="网易云音乐安卓兑换方法"> -->
                    <p>1、点击左上角的【菜单】按钮，呼出侧面导航栏，如图所示；</p>
                    <img src="https://img.chejianlife.com/and2.jpg" alt="网易云音乐安卓兑换方法">
                    <p>2、点击并打开【我的会员】，如图所示；</p>
                    <img src="https://img.chejianlife.com/and3.jpg" alt="网易云音乐安卓兑换方法">
                    <p>3、选择需要充值的方式（黑胶VIP或者音乐包），如图所示；</p>
                    <img src="https://img.chejianlife.com/and4.jpg" alt="网易云音乐安卓兑换方法">
                    <p>4、选择使用会员兑换码，如图所示。</p>
                    <img src="https://img.chejianlife.com/and5.png" alt="网易云音乐安卓兑换方法">
                    <p>5、输入兑换码，点击立即兑换，完成充值</p>
                    <img src="https://img.chejianlife.com/and6.jpg" alt="网易云音乐安卓兑换方法">
                    <p>会员日常使用问题可在网易云音乐上直接搜索用户“云音乐客服”，私信发送问题，我们的客服会及时查看并回复处理</p>
                    <p>客服热线</p>
                    <p>如在购买过程中有任何问题,由杭州云之谷网络科技有限公司负责,请拨打客服热线:</p>
                    <p>0571-85199986</p>
                    <p>如无人接听，请加18158107296微信客服留言。</p>
                </div>
            </div>
        </div>
        <div class="use_loading" v-if="loading">
            <div class="loading">
                <img src="../assets/loading.png" alt="加载中">
            </div>
        </div>
    </div>
</template>
<script>
import QRCode from 'qrcodejs2'; //引入生成二维码插件
import JsBarcode from 'jsbarcode';
// var JsBarcode = require('jsbarcode');
export default {
    data(){
        return{
            loading:true,
            key:this.$route.query.key,
            mobile: this.$route.query.mobile,
            name:'',
            effectiveDate:'',
            expiredDate:'',
            ticket:{},
            regulation: ''
        }
    },
    mounted(){
        this.getTicket();
        
        console.log(this.key);
    },
    methods:{
        getTicket(){
            const obj = {
                ticketNo:this.key,
                isVerify:'-1',
                mobile:this.mobile
            };
            this.$http.POST('productTicket/selectProductTicket',obj).then(res=>{
                this.loading = false;
                console.log(res);
                if(res.code===0){
                    if(res.data.status==2||res.data.status==3){
                        this.used = true;
                    }else{
                        this.used = false;
                        this.ticket = res.data;
                        this.name = this.ticket.ticketName;
                        document.title = this.name;
                    }
                    
                }else{
					
				}
            });
        }
    }
}
</script>
<style lang="scss" scoped>
.wrapper{
    height: 100%;
    position: relative;
    .use{
        // height: 100%;
        background: #108EE9;
        padding: 30px 15px 15px 15px;
        box-sizing: border-box;
        .content{
            background: #fff;
            border-radius: 4px;
            background: url('../assets/code_bg.png') #fff center 20px no-repeat;
            background-size: 305px 338px;
            min-height: 338px;
            position: relative;
            .logo{
                position: absolute;
                display: inline-block;
                right: 0;
                top: 0;
                img{
                    width: 51px;
                    height: 51px;
                }
            }
            .head{
                position: relative;
                height: 30px;
                width: 100%;
                display: flex;
                justify-content: center;
                header{
                    width: 190px;
                    border-top: 30px solid #2C78DC;
                    border-right: 12px solid transparent;
                    border-left:12px solid transparent;
                    box-sizing: border-box;
                    height: 30px;
                }
                .title{
                    font-size: 15px;
                    position: absolute;
                    top: 0;
                    left: 0;
                    color: #fff;
                    width: 100%;
                    height: 30px;
                    line-height: 30px;
                    text-align: center;
                }
            }
            .body{
                border-bottom:1px dashed #CCCCCC;
                p{
                    font-size: 15px;
                    color: #999999;
                    text-align: center;
                    padding-top: 10px;
                }
                h1{
                    font-size: 20px;
                    color: #333333;
                    text-align: center;
                    padding-top: 15px;
                }
                .code{
                    padding-top: 40px;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    .qrcode{
                        padding-top: 20px;
                    }
                    .tip{
                        width:75%;
                        background:yellow;
                        font-size:12px;
                    }
                }
                .sec{
                    font-size: 15px;
                    color: #F76A24;
                    padding: 30px 0 15px 0;
                    text-align: center;
                    font-weight:bold;
                    font-size:16px;
                }
                .dec{
                    font-size: 15px;
                    background: #FEFCEC;
                    padding: 10px 0;
                    color: #F76A24;
                    text-align: center;
                }
                .btn{
                    display: flex;
                    justify-content: center;
                    padding: 15px 0 30px 0;
                    .button{
                        font-size: 15px;
                        width: 200px;
                        height: 40px;
                        line-height: 40px;
                        text-align: center;
                        color: #fff;
                        background: #1E87FC;
                        border-radius: 4px;
                    }
                }
            }
            .foot{
                padding: 24px 17px;
                h1{
                    font-size: 20px;
                    color: #333333;
                    font-weight: bold;
                }
                p{
                    color: #666666;
                    font-size: 15px;
                    line-height: 28px;
                }
                img{
                    max-width:100%;
                    padding:5px 0;
                }
            }
        }
    }
    
    .use_loading{
        position: absolute;
        height: 100%;
        width: 100%;
        z-index: 11;
        left: 0;
        top: 0;
        .loading{
            width: 100%;
            height: 100%;
            background: rgba(0,0,0,0.5);
            display: flex;
            justify-content: center;
            align-items: center;
            img{
                width:50px;
                height: 50px;
                animation:turn .8s linear infinite;      
                margin: 100px auto;
            }
            @keyframes turn{
                0%{-webkit-transform:rotate(0deg);}
                25%{-webkit-transform:rotate(90deg);}
                50%{-webkit-transform:rotate(180deg);}
                75%{-webkit-transform:rotate(270deg);}
                100%{-webkit-transform:rotate(360deg);}
            }
        }
    } 
}
</style>